/**
 * Caretria partner config — placeholder.
 *
 * Fill in once Caretria provides their drug list, products, manufacturers,
 * and final retention/disclosure copy. The shape below supports multiple
 * drugs with per-drug copy overrides on top of `defaultCopy`.
 */

import type { PartnerConfig } from "./types";

const caretria: PartnerConfig = {
  id: "caretria",
  displayName: "Caretria",
  defaultCopy: {
    sampleRequestInstructions: [
      "Federal Law under the Prescription Drug Marketing Act (PDMA) requires that you indicate your professional designation, State License Number, and sign and date this form. These samples may not be sold, offered for sale, traded or bartered. Failure to complete this form as required by the PDMA regulations may result in disqualification of future shipments.",
      "Any samples provided in response to this request form are limited to the provider named on this form and the specific address listed for that provider. To the extent multiple prescribers at the same address seek samples for their patients or a single prescriber seeks samples for patients at multiple addresses, a separate form is required for each prescriber at each address.",
    ],
    // Matches the manufacturer line on BI's original Sample Request Form.
    // Caretria fulfills Boehringer Ingelheim samples; if Caretria ever
    // onboards a non-BI drug, override this per-drug via drugs[].copy.
    distributorText: "Manufactured & distributed by: Boehringer Ingelheim",
    signatureCertificationText:
      "My signature certifies that I am a licensed practitioner who can legally prescribe in my state and that I have all the necessary documentation required by law for me to request, sign for, receive and prescribe these samples. If I am a practitioner with dependent authority in my state, I certify that I have a current Collaborative Agreement on file with my collaborating physician, which includes the samples requested. I have requested the samples shown on this document for the medical needs of my patients. I will not sell, offer to sell, trade or barter samples nor will I seek reimbursement from any payer for providing these samples to a patient.",
    stateLicensureNotice:
      "For practitioners in Ohio and Massachusetts, these states have laws that require healthcare providers to obtain additional licenses to be able to receive samples of pharmaceutical products. You can access the Board's guidance document on prescriber licensure requirements at https://www.pharmacy.ohio.gov/Licensing/TDDD.aspx and https://www.mass.gov/mcsr-for-individuals. In order to ensure compliance with the state laws and to provide you with product samples, your signature will serve as your attestation that you have the required license under the law or qualify for an exemption.",
  },
  drugs: {
    Stiolto: {
      // Product row copy matches the "Stiolto configuration" spec supplied by
      // BI (kristen.ferrucci@boehringer-ingelheim.com, Aug 21 2026).
      products: [
        {
          totalQuantity: "5",
          productGroup: "Stiolto",
          genericName: "tiotropium bromide / olodaterol",
          productDescription:
            "Stiolto 2.5mcg/2.5mcg Sample (28 Actuation Inhaler with Respimat Cartridge Sample)",
          ndc: "00597-0155-28",
          code: "00597015528",
        },
      ],
    },
  },
};

export default caretria;
